class StickySubnav extends HTMLElement {
  connectedCallback() {
    this.trigger = document.querySelector('.product__outer');
    this.links = this.querySelectorAll('.pdp-subnav__link');

    if (!this.trigger) return;

    this.initStickyObserver();
    this.initAnchorLinks();
    this.initSectionObserver();
  }

  initStickyObserver() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        // isIntersecting flips false once .product__outer's top
        // crosses -650px — same boundary .sticky-addtocart uses
        this.classList.toggle('is-visible', !entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '-650px 0px 0px 0px',
      }
    );

    this.observer.observe(this.trigger);
  }

  initAnchorLinks() {
    this.links.forEach((link) => {
      link.addEventListener('click', this.onLinkClick.bind(this));
    });
  }

  onLinkClick(event) {
    event.preventDefault();

    const href = event.currentTarget.getAttribute('href');
    const target = href && document.querySelector(href);
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  initSectionObserver() {
    this.sections = [...this.links]
      .map((link) => {
        const href = link.getAttribute('href');
        const section = href && document.querySelector(href);

        // Hide subnav links whose target isn't rendered on the page —
        // either the block/metafield content is empty, or the target
        // section was removed from the template. "#top" is a fixed
        // scroll action, not a page section, so it's exempt.
        if (href !== '#top') {
          link.hidden = !section;
        }

        return section ? { link, section } : null;
      })
      .filter(Boolean);

    this.sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const active = this.sections.find((item) => item.section === entry.target);
          if (!active) return;

          this.links.forEach((link) => link.classList.remove('active'));
          active.link.classList.add('active');
        });
      },
      { threshold: 0.4 }
    );

    this.sections.forEach(({ section }) => this.sectionObserver.observe(section));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.sectionObserver?.disconnect();
  }
}

if (!customElements.get('sticky-subnav')) {
  customElements.define('sticky-subnav', StickySubnav);
}